import _ from "lodash";
export default {
  emailIsValid(email) {
    var emailRequirement = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRequirement.test(email);
  },
  nullableString(s) {
    return s ? s : "";
  },
  resolveValue: function(obj, id, name) {
    if (obj) return obj;
    if (id === null) return null;
    return { value: id, label: name };
  },
  resolveValueFromList: function (list, value) {
    if (list.length === 0) return;
    return _.find(list, x => { return x.value === value});
  },
  truncateStringOverLength(stringVal, truncateOverLength, addEllipsis) {
    if (
      stringVal &&
      stringVal.length &&
      stringVal.length > truncateOverLength
    ) {
      return `${stringVal.substring(0, truncateOverLength)}${
        addEllipsis ? "..." : ""
        }`;
    }
    return stringVal;
  },
};



// WEBPACK FOOTER //
// ./src/helpers/stringHelper.js